import { Firestore } from '../../config/firebase';
import { collection, query, where, limit, onSnapshot, getDocs, doc, getDoc } from 'firebase/firestore';

function formatTime(seconds) {
  if (seconds == 0) return '00:00.00';
  if (isNaN(seconds)) return '00:00.00';
  try {
    return new Date(seconds * 1000).toISOString().substr(11, 8);
  } catch (e) {
    console.log("invalid time", seconds);
    return '00:00.00';
  }
}

const RaceState = Object.freeze({
  NotStarted: 'NotStarted',
  Prestart: 'Prestart',
  Five: 'Five',
  Four: 'Four',
  One: 'One',
  ConfirmStart: 'ConfirmStart',
  IndRecall: 'IndRecall',
  InProgress: 'InProgress',
  Finishing: 'Finishing',
  Finished: 'Finished'
});

function getRaceState(state) {
  if (!state) return RaceState.NotStarted;
  
  const validState = Object.values(RaceState).find(s => s === state);
  if (!validState) {
    console.warn(`Invalid race state: ${state}, defaulting to NotStarted`);
    return RaceState.NotStarted;
  }
  
  return validState;
}

function transformResult(data) {
  let laps = data['laps'];
  let lastLap = laps.length > 0 ? laps[laps.length - 1] : '0/0/0';
  let triplet = lastLap.split('/');
  data.elapsed = parseInt(triplet[0]);
  data.elapsedStr = formatTime(data.elapsed);
  data.corrected = parseFloat(triplet[1]);
  data.correctedStr = formatTime(Math.round(data.corrected));
  if (!data.bce) data.bce = 0;
  if (!data.bcr) data.bcr = 0;
  data.bceStr = formatTime(Math.round(data.bce));
  data.lapCount = data.laps.length;
  data.average = data.corrected / data.lapCount;
  data.averageStr = formatTime(Math.round(data.average));
  data.bcrStr = data.bcr.toFixed(2);
  // transform laps into lap times
  let lapTimes = data.laps.map(lap => {
    let triplet = lap.split('/');
    let lapTime = parseInt(triplet[0]);
    return lapTime;
  });

  let bestLap = 0;
  let worstLap = 0;
  lapTimes.forEach((lapTime, index) => {
    let prevLapTime = lapTimes[index-1] || 0;
    let thisLap = lapTime - prevLapTime;
    if (index == 0 || thisLap < bestLap) bestLap = thisLap;
    if (index == 0 || thisLap > worstLap) worstLap = thisLap;
  });
  data.bestLap = bestLap;
  data.bestLapStr = formatTime(Math.round(bestLap));
  data.worstLap = worstLap;
  data.worstLapStr = formatTime(Math.round(worstLap));
  if (data.code == 'DNS') {
    data.bestLapStr = '-';
    data.worstLapStr = '-';
    data.correctedStr = '-';
    data.averageStr = '-';
    data.elapsedStr = '-';
    data.bceStr = '-';
    data.bcrStr = '-';
  }
  return data;
}

const transformResults = (snap) => {
  let results = snap.docs.map(doc => transformResult(doc.data()));

  results.sort((a, b) => a.corrected == 0.0 ? 1 :
    b.corrected == 0.0 ? -1 :
      a.corrected < b.corrected ? -1 : 0);

  let maxFinishers = results.filter(r => r.code == 'FIN').length;

  results.map((r, i) => r.code == 'FIN' ? r.pos = i + 1 :
    r.pos = maxFinishers + 1);

  return results;
}

const raceDb = () => {
  const queryResults = async (raceId) => {
    const resultsRef = collection(Firestore, `races/${raceId}/results`);
    const q = query(resultsRef, where('talliedOn', '==', true), limit(100));
    const snap = await getDocs(q);
    return transformResults(snap);
  }

  const subscribeResults = async (raceId, callback) => {
    const resultsRef = collection(Firestore, `races/${raceId}/results`);
    const q = query(resultsRef, where('talliedOn', '==', true), limit(100));
    
    return onSnapshot(q, (snap) => {
      callback(transformResults(snap));
    });
  }

  return Object.freeze({
    queryResults,
    subscribeResults
  })
}

const Race = raceDb()

export { Race }

